import { hasLocizeTranslation } from 'lib/utils/locize'

export const hasShippingQuote = (summary) =>
  Number.isFinite(summary?.shipping_fee) &&
  summary.shipping_fee >= 0 &&
  (summary.shipping_fee === 0 ||
    (typeof summary.shipping_fee_formatted === 'string' &&
      !!summary.shipping_fee_formatted.trim()))

export const getCostClarityCopy = (t, language) => {
  const thai = language === 'th'
  return {
    total: hasLocizeTranslation(
      t,
      'CART_CURRENT_TOTAL',
      thai ? 'ยอดรวมปัจจุบัน' : 'Current total',
    ),
    shippingPending: hasLocizeTranslation(
      t,
      'CART_SHIPPING_PENDING',
      thai ? 'คำนวณเมื่อชำระเงิน' : 'Calculated at checkout',
    ),
    pendingNote: hasLocizeTranslation(
      t,
      'CART_TOTAL_PENDING_NOTE',
      thai
        ? 'ค่าจัดส่งและยอดรวมสุดท้ายจะยืนยันในขั้นตอนชำระเงิน'
        : 'Shipping and final total confirmed at checkout.',
    ),
    quotedNote: hasLocizeTranslation(
      t,
      'CART_TOTAL_QUOTED_NOTE',
      thai
        ? 'ค่าจัดส่งอาจเปลี่ยนตามวิธีจัดส่ง กรุณาตรวจสอบยอดรวมสุดท้ายในขั้นตอนชำระเงิน'
        : 'Shipping may change with delivery choice. Review final total at checkout.',
    ),
    voucherApplied: hasLocizeTranslation(
      t,
      'CART_VOUCHER_APPLIED',
      thai ? 'ใช้คูปองแล้ว' : 'Voucher applied',
    ),
  }
}
